import { StyleManager } from "@levelapp/softfabric-ui";
import Constants from "../Constants/Constants";

export default class MyStyleManager extends StyleManager
{
    primaryColor = Constants.MainColor;
}